import React from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";

const ContractorList = ({
  contractorData,
  handleEdit,
  handleDelete,
}) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Name</th>
          <th>Contact Number</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
        {contractorData.map((data, index) => (
          <tr key={data.id || index}>
            <td>{index + 1}</td>

            <td style={{ textTransform: "capitalize" }}>
              {data.name}
            </td>

            <td>
              {data.contact_number}
            </td>

            <td>
              <div className="d-flex gap-2">

                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => handleEdit(data)}
                >
                  <Edit size={14} />
                </Button>

                {handleDelete && (
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(data.id)}
                  >
                    <Trash size={14} />
                  </Button>
                )}

              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ContractorList;